<template>
  <div id="app" class="app">
    <nav>
      <div class="app__logo">
        <logo />
      </div>
      <div class="app__menu">
        <nav-menu v-if="isLoaded"></nav-menu>
      </div>
      <div class="app__user">
        <user></user>
      </div>
    </nav>
    <main>
      <router-view v-if="isLoaded" />
      <loader fill v-else />
    </main>
    <footer >
      <page-footer v-if="isLoaded"></page-footer>
    </footer>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Loader from '@/components/Loader.vue';
import Logo from '@/components/Logo.vue';
import NavMenu from '@/components/NavMenu.vue';
import User from '@/components/User.vue';
import PageFooter from '@/components/PageFooter.vue';

export default {
  name: 'App',
  components: {
    Loader,
    Logo,
    NavMenu,
    User,
    PageFooter,
  },
  data() {
    return {
      isLoaded: false,
    };
  },
  computed: {
    ...mapGetters(['getUser']),
    userIsAdmin() {
      return this.getUser && this.getUser.isAdmin;
    },
    isAdminRoute() {
      return this.$route.matched.find(route => route.name === 'Admin') !== undefined;
    },
    setAdmin() {
      const isBaseRoute = this.$route.name === null;
      return this.userIsAdmin && (isBaseRoute || this.isAdminRoute);
    },
  },
  methods: {
    ...mapActions(['set', 'fetch', 'fetchSite']),
    setMode() {
      this.set({
        model: 'mode',
        value: this.setAdmin ? 'admin' : 'reader',
      });
    },
  },
  created() {
    const dataRequests = [
      this.fetchSite(),
      this.fetch({ model: 'seasons' }),
    ];
    Promise.all(dataRequests).then(() => {
      this.setMode();
      this.isLoaded = true;
    });
  },
};
</script>

<style lang="scss">
/* Reset */
@import 'styles/variables.scss';
@import 'styles/reset.scss';
@import 'styles/type.scss';

/* Global */
@import 'styles/flex.scss';
@import 'styles/button.scss';
@import 'styles/animation.scss';
</style>

<style lang="scss" scoped>
.app {
  display: block;
  nav, main, footer {
    position: relative;
  }
  nav, footer {
    width: 100%;
    padding: 0 30px;
    @media all and (max-width: 600px) {
      padding: 0 20px;
    }
  }
  nav {
    height: 100px;
    background: var(--color-light);
    > div {
      height: 100px;
      display: flex;
      align-items: center;
    }
  }
  &__logo, &__user {
    position: fixed;
    overflow: visible;
    z-index: 2;
    @media all and (max-width: 600px) {
      position: absolute;
    }
  }
  &__logo {
    top: 0;
    left: 30px;
    @media all and (max-width: 600px) {
      left: 10px;
    }
  }
  &__menu {
    justify-content: center;
  }
  &__user {
    top: 0;
    right: 30px;
    justify-content: flex-end;
  }
  main {
    min-height: calc(100vh - 200px);
    @media all and (max-width: 600px) {
      min-height: calc(100vh - 200px);
    }
  }
  footer {
    height: 80px;
    display: flex;
    align-items: center;
    background: var(--color-light);
    @media all and (max-width: 1000px) {
      height: auto;
    }
  }
}
</style>
